
import { typeIcon } from '@/utils/partnerLocator'

export default {
  name: 'PartnerTypeLinks',
  data() {
    return {
      types: [],
    }
  },
  async mounted() {
    try {
      const { data } = await this.$partnerService.fetchTypes()
      this.types = data || []
    } catch (error) {
      this.types = []
    }
  },
  methods: {
    icon: typeIcon,
  },
}
